// src/SocketContext.js

import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { API_URL } from './config'; // استيراد الرابط المركزي

// 1. إنشاء الـ Context
const SocketContext = createContext(null);

/**
 * Custom hook لتسهيل الوصول إلى الـ socket من أي مكون
 * مثال للاستخدام: const socket = useSocket();
 */
export const useSocket = () => useContext(SocketContext);

/**
 * 2. إنشاء المكون "المزوّد" (Provider)
 * هذا المكون سيقوم بإنشاء اتصال الـ Socket وتوفيره لجميع المكونات الفرعية
 */
export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        // يتم تنفيذ هذا الكود مرة واحدة فقط عند تحميل التطبيق
        const token = localStorage.getItem('token');
        
        // لا تقم بالاتصال إذا لم يكن هناك توكن (المستخدم لم يسجل دخوله)
        if (!token) return;

        // إنشاء اتصال واحد فقط باستخدام الرابط من ملف الإعدادات
        const newSocket = io(API_URL, {
             // يمكنك إضافة إعدادات إضافية هنا إذا احتجت
        });

        // عند نجاح الاتصال، قم بتعريف المستخدم (الأدمن) للسيرفر
        newSocket.on('connect', () => {
            console.log('[SocketProvider] Global socket connected successfully.');
            newSocket.emit('authenticate', token);
        });

        newSocket.on('disconnect', () => {
            console.log('[SocketProvider] Global socket disconnected.');
        });
        
        // تخزين نسخة الـ socket في الـ state لتكون متاحة لباقي التطبيق
        setSocket(newSocket);

        // دالة التنظيف: يتم استدعاؤها عند إغلاق التطبيق لقطع الاتصال
        return () => {
            console.log('[SocketProvider] Disconnecting global socket.');
            newSocket.disconnect();
        };
    }, []); // القوس الفارغ يعني أن هذا التأثير يعمل مرة واحدة فقط

    // 3. توفير الـ socket لجميع المكونات داخل التطبيق
    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};